(function () {
  var P = [
    ["Escoge lo que necesitas", "Choose what you need"],
    ["Colecciones", "Collections"],
    ["Ver el catálogo", "View the catalog"],
    ["Ver todo", "View all"],
    ["Agregar al carrito", "Add to cart"],
    ["Agregar", "Add"],
    ["Elegir", "Choose"],
    ["Cantidad", "Quantity"],
    ["También te puede gustar", "You may also like"],
    ["Elige tu regalo", "Choose your gift"],
    [
      "Compras mayores a $50 te dan un regalo. Un regalo por pedido. Sin costo extra.",
      "Orders over $50 include a gift. One gift per order. No extra cost.",
    ],
    [
      "Envío internacional · el plazo se ve al pagar · Pago seguro",
      "International shipping · delivery time shown at checkout · Secure payment",
    ],
    [
      "Deja tu correo para avisos del pedido y novedades.",
      "Leave your email for order updates and news.",
    ],
    ["Términos y políticas", "Terms & policies"],
  ];
  function lang() {
    var loc =
      (window.Shopify && Shopify.locale) ||
      document.documentElement.lang ||
      "es";
    loc = String(loc).toLowerCase();
    return loc.indexOf("en") === 0 ? "en" : "es";
  }
  function apply(l) {
    document.documentElement.setAttribute("data-cn-lang", l);
    document.querySelectorAll(".cn-es").forEach(function (el) {
      el.hidden = l !== "es";
    });
    document.querySelectorAll(".cn-en").forEach(function (el) {
      el.hidden = l !== "en";
    });
    var enPack = document.querySelector(".cn-en[data-title]");
    var h1 = document.querySelector(".product-information h1, h1");
    if (h1) {
      if (!h1.getAttribute("data-title-es"))
        h1.setAttribute("data-title-es", h1.textContent.trim());
      if (l === "en" && enPack && enPack.getAttribute("data-title"))
        h1.textContent = enPack.getAttribute("data-title");
      else h1.textContent = h1.getAttribute("data-title-es") || h1.textContent;
    }
    document.querySelectorAll("h1,h2,h3,p,a,span,button,label").forEach(function (el) {
      if (el.closest && (el.closest(".cn-buy-blurb") || el.closest(".cn-story") || el.tagName === "H1"))
        return;
      if (el.children.length) return;
      var t = (el.textContent || "").trim();
      P.forEach(function (p) {
        if (t === p[0] || t === p[1]) el.textContent = l === "en" ? p[1] : p[0];
      });
    });
  }
  function layoutProduct() {
    var blurb = document.querySelector("[data-cn-blurb]");
    if (!blurb || blurb.getAttribute("data-cn-ready")) return;
    blurb.setAttribute("data-cn-ready", "1");
    blurb.querySelectorAll("img,table,iframe,video").forEach(function (el) {
      el.remove();
    });
    document.querySelectorAll(".cn-story").forEach(function (el) {
      el.remove();
    });
    apply(lang());
  }
  function mount() {
    document.querySelectorAll(".cn-lang").forEach(function (el) {
      el.remove();
    });
    apply(lang());
    layoutProduct();
  }
  if (document.readyState === "loading")
    document.addEventListener("DOMContentLoaded", mount);
  else mount();
})();
